import { EMPTY_ARRAY } from 'commons-ui';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: 'Add User In Segment',
				id: 'addUserInSegment',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.referral,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.referral].updateUserReferralSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
